<template>
	<validation-observer v-slot="{ invalid }" ref="form" class="form mx-auto">
		<b-form @submit.prevent="submitForm">
			<slot name="header">
				<h4 class="mb-4">
					{{ models.id ? "Update" : "Add" }} Company Admin
				</h4>
			</slot>

			<base-input
				v-model="models.display_name"
				rules="required"
				name="Name"
				label="Name"
			></base-input>

			<base-input
				v-model="models.email"
				rules="required|email"
				name="Email Address"
				label="Email Address"
			></base-input>

			<div class="mt-4 d-flex align-items-start justify-content-between">
				<slot name="return"></slot>
				<div>
					<slot name="submit">
						<base-button
							:disabled="invalid"
							:loading="formProcessing"
							type="primary"
							native-type="submit"
							size="md"
							class="form-btn font-weight-normal"
						>
							<slot name="submit-text">Save</slot>
						</base-button>
					</slot>
					<slot name="submit-extra"></slot>
				</div>
			</div>
		</b-form>
	</validation-observer>
</template>

<script>
export default {
	name: "form-company-admin",
	props: {
		action: {
			type: String,
			default: "create",
			required: true,
		},
		companyId: Number,
	},
	inject: ["ErrorService", "memberSvc"],
	data() {
		return {
			formProcessing: false,
			models: {
				status: "Active",
			},
		};
	},
	watch: {
		"memberSvc.member": {
			deep: true,
			immediate: true,
			handler: function (val) {
				this.models = {
					id: val.id,
					company:
						this.companyId ||
						("object" === typeof val.company
							? val.company.id
							: val.company),
					display_name: val.display_name,
					email: val.user_email,
					type: "Corporate Admin",
					status: "Active",
				};
			},
		},
		formProcessing: function (val) {
			this.$bus.$emit("company-admin-form-processing", val);
		},
	},
	methods: {
		async submitForm() {
			var response;

			this.formProcessing = true;

			if ("create" == this.action)
				response = await this.memberSvc.create(this.models);
			else response = await this.memberSvc.update(this.models);

			if (200 === response.data.status)
				this.$bus.$emit(
					"company-admin-form-success",
					response.data.data.data
				);

			this.$toasted.show(response.data.data.message);

			this.reset();
		},
		reset() {
			this.formProcessing = false;

			this.$refs.form.reset();
		},
	},
	mounted() {
		this.ErrorService.stopProcessingOnFail(this);
	},
	beforeDestroy() {
		this.memberSvc.set("member", null);

		this.reset();
	},
};
</script>
